'use client'
import { NotFoundComponent } from '@/components/NotFound'
import {
  useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery,
  useFindUniqueTeamQuery,
} from '@/graphql/generated/graphql'
import * as React from 'react'
import NotFoundPage from '../components/notFoundPage'
import Loading from '@/components/Loading'
import Header from '../[code]/components/Header'
import { Input } from '@/components/v2/Input'
import Card from '@/components/Card'
import { Label } from '@/components/v2/Label'
import { Button } from '@/components/v2/Button'
import { setTheme, useViewTheme } from '../[code]/theme'
import { useAsyncRoutePush } from '@/utils/nextjsClient'
import SvgLoadingSpin from '@/components/SvgLoadingSping'
import { SearchIcon } from 'lucide-react'
import { useWithoutBasePathname } from '@/utils/nextjs'
import { configs } from '@/configs'
import { usePathname } from 'next/navigation'
import PublicViewCodeTemplate from '../[code]/Template'
import { useApolloSideEffectOnCompleted } from '@/hooks/useApolloSideEffectOnCompleted'

type PublicViewPageProps = {}

export default function PublicViewPageTemplate(props: PublicViewPageProps) {
  const [code, setCode] = React.useState('')
  const [redirecting, setRedirecting] = React.useState(false)
  // const routerPush = useAsyncRoutePush()
  const theme = useViewTheme()
  const pathname = usePathname()

  const basePathname = theme?.url ? new URL(theme.url).pathname : ''
  const pathnameCode =
    basePathname && pathname?.replace(basePathname, '').replace('/', '')

  // console.log({ pathnameCode })

  const { data, loading } =
    useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery({})

  useApolloSideEffectOnCompleted(
    data?.findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl,
    (data) => {
      if (data?.team) {
        setTheme(data)
      }
    },
  )

  const item = data?.findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl

  if (pathnameCode) return <PublicViewCodeTemplate />

  if (loading) return <Loading />
  if (item === null) return <NotFoundPage />
  if (!item) return null

  return (
    <div className="bg-gray-50 w-full">
      <Header />
      {/* {configs.IS_DEVELOPMENT && (
        <div>{JSON.stringify({ pathname, basePathname, pathnameCode })}</div>
      )} */}
      <form
        onSubmit={async (e) => {
          e.preventDefault()
          if (!theme) return
          const url = theme.url
          const newUrlReplaced = `${url}/${code}`
          console.log({ newUrlReplaced })
          window.history.pushState(null, '', newUrlReplaced)
        }}
        className="font-medium text-slate-700 max-w-6xl mx-auto"
        style={{ minHeight: `calc(100vh - 67px)` }}
      >
        <Card className="mt-4 p-4">
          <Label className="h-8" htmlFor="validation_code">
            Código de Validação do {theme?.documentSeeType}
          </Label>
          <Input
            required
            // focus must have border black
            className="focus:border-black"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            id="validation_code"
            placeholder="Digite o código de validação"
          />
          <div className="flex justify-end">
            <Button
              disabled={redirecting}
              type="submit"
              variant="outline"
              className="mt-4"
            >
              {redirecting ? (
                <SvgLoadingSpin className="h-5 w-5 mr-2" color="dark" />
              ) : (
                <SearchIcon className="h-5 w-5 mr-2" />
              )}
              <span>Validar</span>
            </Button>
          </div>
        </Card>
      </form>
    </div>
  )
}
